import { getRequest } from 'src/utils/http';

import { catalogsController } from './consts';

export const listCenters = async (params) => getRequest(`${catalogsController}/centers`, params);
export const listDrugs = async (params) => getRequest(`${catalogsController}/drugs`, params);
export const getDrugById = async (id, params) => getRequest(`${catalogsController}/drugs/${id}`, params);